import { PropsWithChildren } from 'react'
import Header from 'components/Navigation/Header'
import { Box, CssBaseline, SxProps } from '@mui/material'
import Sidebar from 'components/Navigation/Sidebar'
import { useAppDispatch, useAppSelector } from 'redux/hooks'
import { selectAppSidebarShow } from 'redux/App/app.selectors'
import appActions from 'redux/App/app.action'
import wrapperStyles from './MainWrapper.style'

export default function MainWrapper({ children }: PropsWithChildren) {
  const dispatch = useAppDispatch()
  const open = useAppSelector(selectAppSidebarShow)

  const toggleDrawer = () => {
    dispatch(appActions.updateAppSidebarShow(!open))
  }

  const onClose = () => {
    dispatch(appActions.updateAppSidebarShow(false))
  }

  return (
    <Box sx={wrapperStyles.wrapper}>
      <CssBaseline />
      <Header open={open} handleDrawerOpen={toggleDrawer} />
      <Sidebar open={open} onClose={onClose} />
      <Box component="main" sx={[wrapperStyles.contentWrapper, !open && wrapperStyles.contentWrapperClosed] as SxProps}>
        {children}
      </Box>
    </Box>
  )
}
